import ViewConfig from '../../../reducers/ViewConfigType';
import { isFieldViewField, isBooleanField, getAllFieldsFromView } from './viewConfigUtils';

const getBooleanFieldsPreloadedFalse = (
    viewConfig: ViewConfig,
    viewName: string,
): {
    [booleanField: string]: false;
} => {
    if (!viewConfig.views[viewName]) {
        console.error(`invalid viewName "${viewName}"`); // tslint:disable-line
        return {};
    }
    return Object.assign(
        {},
        ...getAllFieldsFromView(viewConfig, viewName).flatMap(f => {
            if (
                isFieldViewField(f) &&
                isBooleanField(viewConfig, f.entity, f.field, 'POP_LAST') &&
                f.widgetType !== 'NULLABLE_BOOLEAN'
            ) {
                return [{ [f.field]: false }];
            }
            return [];
        }),
    );
};
export default getBooleanFieldsPreloadedFalse;
